import React from 'react';
import { Icon, IconNames } from '@sovryn/ui';
export const GoBackButton = ({ onClick }) => (React.createElement("button", { onClick: onClick, className: "mb-12 md:mb-0" },
    React.createElement(Icon, { icon: IconNames.ARROW_LEFT, className: "w-3 h-3" })));
